module.exports = __webpack_public_path__ + "images/emoji/no_entry.e38aa7e68374bf5d8394.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/no_entry.png
// module id = FpCj
// module chunks = 24